/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ShipmentReportInvoiceWarningState {
  BookingSuspendedDueToOverdueInvoices = "booking_suspended_due_to_overdue_invoices",
  BookingSuspendedDueToOverCreditLimit = "booking_suspended_due_to_over_credit_limit",
  BookingWarningInvoicesCloseToOverdue = "booking_warning_invoices_close_to_overdue",
  BookingWarningCloseToCreditLimit = "booking_warning_close_to_credit_limit",
  NoWarning = "no_warning",
  BookingSuspendedNeedsAccountVerification = "booking_suspended_needs_account_verification",
  BookingSuspendedAccountOnHold = "booking_suspended_account_on_hold",
}

export function instanceOfShipmentReportInvoiceWarningState(
  value: any,
): boolean {
  for (const key in ShipmentReportInvoiceWarningState) {
    if (
      Object.prototype.hasOwnProperty.call(
        ShipmentReportInvoiceWarningState,
        key,
      )
    ) {
      if (
        ShipmentReportInvoiceWarningState[
          key as keyof typeof ShipmentReportInvoiceWarningState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentReportInvoiceWarningStateFromJSON(
  json: any,
): ShipmentReportInvoiceWarningState {
  return ShipmentReportInvoiceWarningStateFromJSONTyped(json, false);
}

export function ShipmentReportInvoiceWarningStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentReportInvoiceWarningState {
  return json as ShipmentReportInvoiceWarningState;
}

export function ShipmentReportInvoiceWarningStateToJSON(
  value?: ShipmentReportInvoiceWarningState | null,
): any {
  return value as any;
}

export function ShipmentReportInvoiceWarningStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentReportInvoiceWarningState {
  return value as ShipmentReportInvoiceWarningState;
}
